import { Injectable } from '@angular/core';
import { URL_SERVICIOS, HTTP_OPTIONS } from '../shared/config/config';
import { HttpClient } from '@angular/common/http';
import { VehicleSelection } from '../interfaces/interfaces.index';
import { VehicleConfirmation, VehicleProcessValidation, VehicleValidation, VehicleProcessValidationPut } from '../interfaces/vehicle-selection';
const URL = `${URL_SERVICIOS}VehicleSelection`;

@Injectable({
  providedIn: 'root'
})
export class VehicleSelectionService {

  constructor(private http: HttpClient) { }

  setVehicleStore = (vehicle: VehicleSelection) => sessionStorage.setItem('Vehicle', JSON.stringify(vehicle));

  postVehicleSelection = (vehicleSelection: VehicleSelection) =>
    this.http.post<VehicleSelection[]>(URL, JSON.stringify(vehicleSelection), HTTP_OPTIONS)

  postVehicleConfirmation = (vehicleConfirmation: VehicleConfirmation) =>
    this.http.post<VehicleConfirmation[]>(URL, JSON.stringify(vehicleConfirmation), HTTP_OPTIONS)

  saveConfirmation = (doc: VehicleConfirmation[]) =>
    this.http.post(`${URL}/confirmation`, doc, HTTP_OPTIONS)

  getVehicleStore = () => {
    if (sessionStorage.getItem('Vehicle')){
      return JSON.parse(sessionStorage.getItem('Vehicle'));
    }
  }

  getByPetitionId = (id: number) => this.http.get<VehicleSelection>(`${URL}/petition/${id}`, HTTP_OPTIONS);

  getCartaCompromiso = (id: number, documentCorrection = false, onlyView = false) => this.http.get(`${URL}/getCartaCompromiso/${id}/documentCorrection/${documentCorrection}?onlyView=${onlyView}`, { responseType: 'text' });

  deleteVehicleStore = () => {
    if (sessionStorage.getItem('Vehicle')){
      sessionStorage.removeItem('Vehicle');
    }
  }

  putVehicleValidation = (vehicleValidation: VehicleValidation) =>
    this.http.put<VehicleValidation>(`${URL}/putVehicleValidation`, JSON.stringify(vehicleValidation), HTTP_OPTIONS);

  putVehicleSelection = (vehicleSelection: VehicleSelection) =>
  this.http.put<VehicleSelection>(`${URL}/PutVehicleSelection`, JSON.stringify(vehicleSelection), HTTP_OPTIONS);

  getVehicleValidation = (petitionId: number) =>
  this.http.get<VehicleProcessValidation>(`${URL}/petitionId/${petitionId}`, HTTP_OPTIONS)

  getVehicleSelection = (petitionId: number) =>
  this.http.get<VehicleProcessValidation>(`${URL}/petition/${petitionId}`, HTTP_OPTIONS)

  putVehicleSaveControlProcess = (vehicleValidation: VehicleProcessValidationPut) =>
  this.http.put<VehicleProcessValidationPut>(`${URL}/SaveProcessControlValidation`, JSON.stringify(vehicleValidation), HTTP_OPTIONS)
}
